import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { PageHero } from '#app/components/page-hero.tsx'
import { SectionLayout } from '#app/components/section-layout.tsx'

type Props = {
	eyebrow?: string
	title: React.ReactNode
	intro?: React.ReactNode
	/** Optional extra context shown inside the placeholder block. */
	note?: React.ReactNode
}

/**
 * Placeholder page. Renders the standard hero + section layout so the
 * navigation system can be visualised before we have real content.
 *
 * Delete or replace with real content once a page is built.
 */
export function StubPage({ eyebrow, title, intro, note }: Props) {
	return (
		<>
			<PageHero
				variant="compact"
				eyebrow={eyebrow}
				title={title}
				intro={intro}
			/>
			<SectionLayout>
				<div className="border-border bg-muted/30 border p-8 text-center md:p-12">
					<div className="text-muted-foreground font-mono text-xs font-semibold tracking-widest uppercase">
						Rakenteilla
					</div>
					<h2 className="text-foreground mt-3 text-xl font-bold tracking-tight">
						Tämä sivu on tulossa.
					</h2>
					<p className="text-foreground/70 mx-auto mt-3 max-w-md text-sm leading-relaxed">
						{note ??
							'Sisältö on vielä työn alla. Voit silti tutustua navigaatioon ja siirtyä sivuston muille sivuille.'}
					</p>
				</div>
			</SectionLayout>
		</>
	)
}

export function StubErrorBoundary() {
	return <GeneralErrorBoundary />
}
